import { escapeForJS } from "@app/utils/escapeForJs";
import { GADataProps } from "@components/GAData/GAData";

/**
 * Injects GA data layer script directly into document.head for client-side rendering
 * Use this when GA data needs to be set dynamically after initial page load
 */
export function injectClientGAData(gaData: GADataProps): void {
  const {
    articleid = "",
    at = "", // mysphw cookie
    author = "", // Comma separated author name
    chapter1 = "", // Section child category name.
    contentcat = 1, // Paid (2) or free (1)
    contenttype = "", // Index/listing = "", article = 1 photo = 2 video = 3
    keyword = "", // Comma separated keyword names
    // if in article, level2 = main category parent or main category, main category is the first category
    // if breakingnews, level2 = breaking news
    level2 = "",
    pagination = 1,
    // permutive_id = "", // window.localStorage.getItem("permutive-id") || "",
    pubdate = "", // Post date of article otherwise ""
    story_threads = "", // Comma separated story thread name
    title = "", // ie I am the article title, Section name, Breaking News
    visitorcat = 1,
    termid = "", // Section term id
    product_flag = "(not set)",
    user_keyword = "(not set)",
    cd_version = "bt2", // to determine if from pv is from bt1 or bt2, no value is bt1
    gsChannels = "", // grapeshot keywords
    event = "",
    abVariant = "",
    language = "en",
    adblocker = 0,
    svc = "",
  } = gaData;

  // Remove existing GA data layer script if present
  const existingScript = document.getElementById("ga_data_layer");

  if (existingScript) {
    existingScript.remove();
  }

  const script = document.createElement("script");
  script.id = "ga_data_layer";
  script.innerHTML = `
    var permutiveId = window.localStorage.getItem("permutive-id") || "";
    var _data = {};
    _data = {
      "articleid"      : "${escapeForJS(articleid)}",
      "cue_articleid"  : "${escapeForJS(articleid)}",
      "at"             : "${escapeForJS(at)}",
      "author"         : "${escapeForJS(author)}",
      "chapter1"       : "${escapeForJS(chapter1)}",
      "contentcat"     : "${escapeForJS(contentcat.toString())}",
      "contenttype"    : "${escapeForJS(contenttype)}",
      "keyword"        : "${escapeForJS(keyword)}",
      "level2"         : "${escapeForJS(level2)}",
      "pagination"     : "${escapeForJS(pagination.toString())}",
      "permutive_id"   : window.localStorage.getItem("permutive-id") || "",
      "pubdate"        : "${escapeForJS(pubdate)}",
      "story_threads"  : "${escapeForJS(story_threads)}",
      "title"          : "${escapeForJS(title)}",
      "visitorcat"     : "${escapeForJS(visitorcat.toString())}",
      "termid"         : "${escapeForJS(termid)}",
      "product_flag"   : "${escapeForJS(product_flag)}",
      "user_keyword"   : "${escapeForJS(user_keyword)}",
      "adblocker"      : "${escapeForJS(adblocker.toString())}",
      "cd_version"     : "${escapeForJS(cd_version)}",
      "gs_channels"    : "${escapeForJS(gsChannels)}",
      "event"          : "${escapeForJS(event)}",
      "abVariant"      : "${escapeForJS(abVariant)}",
      "abVariant_user" : "${escapeForJS(abVariant)}",
      "language"       : "${escapeForJS(language)}",
      "svc"            : "${escapeForJS(svc)}",
    };

    var isArticlePage = false;
    if (typeof _data != "undefined" && typeof _data.articleid != "undefined" && _data.articleid != "") {
      isArticlePage = true;
    }

    if(isArticlePage) {
      if (document.querySelector("meta[name='keywords']")) {
        permutive_keys.keywords = document.querySelector("meta[name='keywords']").content.split(",").map((value) => {return value.trim().toLowerCase()});
        permutive_keys.contentcat = "free";
        permutive_keys.contenttype = "article";
        permutive_keys.articleid = _data.articleid;
      }
    }

    function getCookieByName(cname) {
      if (document.cookie.length >0) {
        c_start = document.cookie.indexOf(cname + "=");
        if (c_start != -1) {
          c_start = c_start + cname.length + 1;
          c_end   = document.cookie.indexOf(";", c_start);
          if (c_end == -1) { c_end = document.cookie.length }
          return decodeURIComponent(document.cookie.substring(c_start, c_end))
        }
      }
      return ""
    }

    window.addEventListener('load', function() {
      if(getCookieByName("visitorcat") != undefined && getCookieByName("mysphw") != undefined) {
        var visitorcat = getCookieByName("visitorcat");
        _data.visitorcat = visitorcat;
        _data.at = getCookieByName("mysphw");
      }

      if(getCookieByName("svc") != undefined) {
        var svc = getCookieByName("svc");
        _data.svc = svc;
      }
    });
  `;
  document.head.appendChild(script);
}
